import { __assign } from "tslib";
import { load } from 'cheerio';
import { listPropsInjectorFactory } from './inject-missing-list-props';
import { defaultContainerMissingPropsInjectorFactory, explicitInheritanceFactory, } from './inject-missing-props-into-default-containers';
import { postProcessHtmlFactory } from './post-process-html';
import { linkStyleInjectorFactory } from './inject-missing-link-style';
import { transformElement } from './transform-element';
export var injectMissingPropsIntoHtml = function (html, props, composerData, css, experiments, useChildrenHtml) {
    if (useChildrenHtml === void 0) { useChildrenHtml = false; }
    var injectorFactories = [
        explicitInheritanceFactory,
        defaultContainerMissingPropsInjectorFactory,
        listPropsInjectorFactory,
        postProcessHtmlFactory,
        linkStyleInjectorFactory,
    ];
    var injectors = injectorFactories.map(function (factory) {
        return factory({ html: html, props: props, composerData: composerData, experiments: experiments });
    });
    var cheerioResult = injectors.reduce(function (finalOutput, injector) {
        return injector.elements.reduce(function (injectorOutput, element) {
            return transformElement(element)(injectorOutput, __assign(__assign({}, props), { css: css }), injector.mutators);
        }, finalOutput);
    }, load(html));
    var result = useChildrenHtml
        ? cheerioResult('body').children().html()
        : cheerioResult('body').html();
    result = result.replace(/\n/g, '<br />');
    return result;
};
//# sourceMappingURL=inject-missing-props-into-html.js.map